import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private readonly API_URL = environment.API_URL;

  constructor(
    public http: HttpClient
  ) {}

  public get<T>(endpoint: string): Observable<T> {
    let url = this.constructUrl(endpoint);
    return this.http.get<T>(url);
  }

  public post<T>(endpoint: string, data: any): Observable<T> {
    let url = this.constructUrl(endpoint);
    return this.http.post<T>(url, data);
  }

  public put<T>(endpoint: string, data: any): Observable<T> {
    let url = this.constructUrl(endpoint);
    return this.http.put<T>(url, data);
  }

  public delete<T>(endpoint: string): Observable<T> {
    let url = this.constructUrl(endpoint);
    return this.http.delete<T>(url);
  }

  public download(endpoint: string, fileNamePrefix: string, extension = null, body = null): Promise<string>{
    const url = this.constructUrl(endpoint);
    var httpMethod = body != null
      ? this.http.post(url, body, { responseType: 'blob', observe: 'response' })
      : this.http.get(url, { responseType: 'blob', observe: 'response' });

    return new Promise((resolve, reject) => {
      httpMethod
        .subscribe(
          (response: HttpResponse<Blob>) => {
            /*
              let dataType = response.type;
              let binaryData = [];
              binaryData.push(response);

              const blob = new Blob(binaryData, { type: dataType });
            */
            const url = window.URL.createObjectURL(response.body);

            var downloadLink = document.createElement("a");

            downloadLink.href = url;

            if (fileNamePrefix && extension) {
              downloadLink.download = `${fileNamePrefix}-${new Date().toISOString()}.${extension}`;
            } else {
              var contentDisposition = response.headers.get('Content-Disposition');
              var filename = contentDisposition?.split(';')[1]?.split('filename')[1]?.split('=')[1]?.trim().replace(/"/g, "");

              downloadLink.download = `${filename ?? 'file'}`;
            }

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            resolve(null)
          }
          ,
          error => reject(error));
    });
  }

  private constructUrl(endpoint: string): string {
    return `${this.API_URL}${endpoint}`;
  }

}
